/*eslint-disable */
import axios from "axios"
import { queryFixer } from "common/utils/utils"

const FacturaService = {
  getFormasDePago() {
    return axios.get("/Enum/formas-pago")
  },

  getTiposIva() {
    return axios.get("/tipoIva")
  },

  getFacturasEnviadas({ libradorId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Factura/by-filters?libradorId=${libradorId}`,
      queryState
    )
    return axios.get(query)
  },

  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/${id}/simple`)
  },

  getArchivosAdjuntosById(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/${id}/ficheros-adjuntos`)
  },

  getDocumentosAsociadosById(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/${id}/documentos-asociados`)
  },

  addNewArchivoAdjunto(facturaID: $TSMigrationFixMe, file: $TSMigrationFixMe) {
    return axios.post(`/Factura/${facturaID}/add-fichero-adjunto`, file)
  },

  deleteArchivoAdjunto(
    facturaID: $TSMigrationFixMe,
    fileID: $TSMigrationFixMe
  ) {
    return axios.delete(`/Factura/${facturaID}/fichero/${fileID}`)
  },

  getFacturasRecibidas({ libradoId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Factura/by-filters?libradoId=${libradoId}`,
      queryState
    )
    return axios.get(query)
  },

  getFacturasPendientesDePago({ libradoId, queryState }: $TSMigrationFixMe) {
    queryState.maxResult = 100
    const query = queryFixer(
      `/Factura/by-filters?libradoId=${libradoId}&estadoPago=0&estadoRevision=2`,
      queryState
    )

    return axios.get(query)
  },

  getFacturasPendingTooltip(idActiveBussiness: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Factura/by-filters?libradoId=${idActiveBussiness}&MaxResultCount=100`
    )
    return axios.get(query)
  },

  getFacturasPendingTooltipLibrador(idActiveBussiness: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Factura/by-filters?libradorId=${idActiveBussiness}&MaxResultCount=100`
    )
    return axios.get(query)
  },

  getFacturasPagadas({ libradoId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Factura/by-filters?libradoId=${libradoId}&estadoPago=1`,
      queryState
    )

    return axios.get(query)
  },

  getFacturasWithSameLibradoLibrador({
    libradorId,
    libradoId,
    ...filters
  }: $TSMigrationFixMe) {
    return axios.get("/Factura/by-filters", {
      params: {
        ...filters,
        libradoId,
        libradorId,
      },
    })
  },

  getFacturaByMsgEncrypted({ msgEncrypted, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Factura/by-filters-encrypted?MsgEncrypted=${msgEncrypted}`,
      queryState
    )
    return axios.get(query)
  },

  getPdfById(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/${id}/pdf`, {
      responseType: "blob",
    })
  },

  getXmlFromFactura(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/generate-facturae-xml/${id}`, {
      responseType: "text",
    })
  },

  async getEdiFromFactura(id: $TSMigrationFixMe, formato: $TSMigrationFixMe) {
    // @ts-expect-error TS(2554): Expected 1-2 arguments, but got 3.
    return axios.get(`/Factura/export-edi/${id}/formato/${formato}`, null, {
      responseType: "blob",
    })
  },

  async importarEDI(file: $TSMigrationFixMe) {
    return axios.post("/Factura/import-edi", file)
  },

  changeEstadoFactura({
    documentoId,
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Factura/change-estado", {
      documentoId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },

  changeCesionFactura(
    bodyRequest: $TSMigrationFixMe,
    documentoId: $TSMigrationFixMe
  ) {
    return axios.put(`/Factura/${documentoId}/change-estado-cesion`, {
      ...bodyRequest,
    })
  },

  changeEstadoPagoFactura({ documentoId, estado }: $TSMigrationFixMe) {
    return axios.post(`/Factura/${documentoId}/change-estado-pago/${estado}`)
  },

  changeMultipleEstadoPagoFactura({ documentosId, estado }: $TSMigrationFixMe) {
    return axios.put(`/Factura/bulk-change-estado-pago/${estado}`, documentosId)
  },

  changeMultipleEstados({
    documentosId = [],
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Factura/bulk-change-estado", {
      documentosId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },

  getPlantillaImportacion() {
    return axios.get("/Factura/plantilla-importacion")
  },

  importExcel(excelFormData: $TSMigrationFixMe) {
    return axios.post("/Factura/import-excel", excelFormData)
  },
  getDocumentosPendientesValidar(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Factura/pendientes-firmar${queryParam}`)
  },
  getDocumentoPendienteValidacion(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/${id}/validacion`)
  },
  validateDocumentoPendiente(id: $TSMigrationFixMe, data: $TSMigrationFixMe) {
    return axios
      .post(`/Factura/${id}/aprobacion`, data)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response.data
      })
  },
  getFlujosTesoreriaFromFacturas(id: $TSMigrationFixMe) {
    return axios.get(`/Factura/${id}/flujos-tesoreria`)
  },

  fetchFacturasFinanciables({ queryState }: $TSMigrationFixMe) {
    const query = queryFixer(`/Factura/financiables`, queryState)
    return axios.get(query)
  },
  postFacturaAfinanciar(facturasAfinanciar: $TSMigrationFixMe) {
    return axios.post("/Factura/financiar", facturasAfinanciar)
  },
  getFacturasConciliables(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Factura/conciliables${queryParam}`)
  },
  getFacturaAceptables(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Factura/aceptables/${queryParam}`)
  },

  getFacturaEstadoVerifiacionActualizado() {
    return axios.get("/Factura/any-estado-verificacion-actualizado")
  },
  IsEmpresaActivaHasFacturasToAuthorize(queryParam = "") {
    return axios.get(`/Factura/any/${queryParam}`)
  },
}

export default FacturaService
